import React, { lazy } from 'react';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import ProtectedRoute from 'src/pages/utility/ProtectedRoute';
import { getCrumb } from 'src/components/MainPage/_shared/Breadcrumbs/Breadcrumb';
import { roleSet } from 'src/constants/role';
import type { AppRoute } from '../types';
import { SuspenseContainer } from 'src/components/MainPage/_shared/page';

const ReviewsPage = lazy(() => import('src/pages/reviews/ReviewsPage'));
const ReviewPage = lazy(() => import('src/pages/reviews/ReviewPage'));

export const reviewsRoute: AppRoute = {
  path: `reviews`,
  element: <ProtectedRoute roles={roleSet.operatorToSuperAdmin} />,
  handle: {
    label: 'Отзывы',
    icon: <StarHalfIcon />,
    roles: roleSet.operatorToSuperAdmin,
    keepPlain: true,
    crumb: getCrumb('Отзывы', true),
  },
  children: [
    {
      index: true,
      element: <ReviewsPage />,
    },
    {
      path: `:id`,
      element: (
        <SuspenseContainer>
          <ReviewPage />
        </SuspenseContainer>
      ),
      async lazy() {
        const { reviewLoader } = await import(
          'src/pages/reviews/ReviewPage/reviewLoader'
        );
        return {
          loader: reviewLoader,
        };
      },
    },
  ],
};
